<style lang="stylus">
.announcements {
  color: #191919;
  padding: 1.4rem 0.8rem;
}

button:focus {
  outline: none;
}

.annoucement-links a {
  color: #8c1d40;
  text-decoration: underline;
}

.annoucement-links li {
  margin-left: 32px;
}

.announcement-badge {
  background-color: #8c1d40;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  margin-left: 8px;
}
</style>

<template>
  <v-row v-if="announcements.length > 0">
    <p
      class="pa-4 mb-0 text-h6 font-weight-bold"
      style="display: flex; align-items: center; justify-content: space-between; cursor: pointer; width: 100%"
      @click="toggleCollapse"
    >
      <span style="display: flex; align-items: center">
        Announcements
        <span v-if="unreadCount > 0" class="announcement-badge">{{ unreadCount }}</span>
      </span>
      <v-icon size="28px" color="#747474">
        {{ isCollapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
      </v-icon>
    </p>
    <v-expand-transition>
      <div v-show="!isCollapsed">
        <v-divider class="my-0" style="border-color: #d0d0d0; opacity: 1" />
        <v-row class="pa-4">
          <div class="">
            <div class="text-center">
              <v-col cols="12">
                <img src="../assets/images/forks-up.svg" />
              </v-col>
              <v-col
                cols="12"
                class="title font-weight-bold"
                style="line-height: 2rem !important; font-size: 18px !important"
              >
                <span>Hello, {{ studentName }}!</span>
                <br />
                <span>Welcome to your learner portal</span>
              </v-col>
            </div>
            <v-divider class="my-4" style="border-color: #000; opacity: 1" />
            <div>
              <div v-for="(annoucement, i) in announcements" :key="i">
                <v-row
                  v-if="annoucement"
                  :style="{
                    'border-bottom': i < announcements.length - 1 ? '2px solid #68737c' : ''
                  }"
                >
                  <v-col cols="1" md="2" lg="1" sm="1">
                    <v-icon style="font-size: 1.4rem" color="black">mdi-message-text-outline</v-icon>
                  </v-col>
                  <v-col cols="11" md="10" lg="11" sm="11">
                    <span
                      class="subheading font-weight-regular annoucement-links"
                      v-html="annoucement.body || annoucement"
                    />
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </v-row>
      </div>
    </v-expand-transition>
  </v-row>
</template>
<script>
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useUserStore } from '@/stores/user';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';

const STORAGE_KEY = 'read_announcements';

export default defineComponent({
  name: 'AnnouncementComponent',
  data() {
    return {
      gpaCalculatorPage: 'https://ea.asu.edu/gpa-calculator',
      isCollapsed: false,
      readAnnouncementIds: []
    };
  },

  computed: {
    ...mapState(useUserStore, ['getLearnerData']),
    announcements() {
      const learnerData = this.getLearnerData;
      return (learnerData?._studentAnnouncements || [])
        .concat([((this.$conn.partnerData || {}).dashboardPageData || {}).studentPortalAnnouncement])
        .filter((e) => !!e);
    },
    studentName() {
      const learnerData = this.getLearnerData;
      return learnerData?.learnerPreferedName?.preferredFirstName || learnerData?._firstName || '';
    },
    unreadCount() {
      return this.announcements.filter((announcement) => {
        const id = this.generateAnnouncementId(announcement);
        return !this.readAnnouncementIds.includes(id);
      }).length;
    }
  },

  mounted() {
    // Load collapsed state from localStorage
    const savedState = localStorage.getItem('announcements_collapsed');
    if (savedState !== null) {
      this.isCollapsed = savedState === 'true';
    }

    // Load read announcements from localStorage
    this.loadReadAnnouncements();
  },

  methods: {
    generateAnnouncementId(announcement) {
      // Create a simple hash from the announcement content
      if (announcement?.id) return String(announcement.id);
      let hash = 0;
      const str = typeof announcement === 'string' ? announcement : announcement?.body || String(announcement);
      for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32bit integer
      }
      return String(hash);
    },

    loadReadAnnouncements() {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          this.readAnnouncementIds = JSON.parse(stored);
        }
      } catch (e) {
        this.readAnnouncementIds = [];
      }
    },

    markAllAsRead() {
      const currentIds = this.announcements.map((a) => this.generateAnnouncementId(a));
      // Merge with existing read IDs and remove duplicates
      const allReadIds = [...new Set([...this.readAnnouncementIds, ...currentIds])];
      this.readAnnouncementIds = allReadIds;

      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(allReadIds));
      } catch (e) {
        // localStorage might be full or unavailable
      }
    },

    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      // Save state to localStorage
      localStorage.setItem('announcements_collapsed', this.isCollapsed.toString());

      // Mark announcements as read when expanding (user is viewing them)
      if (!this.isCollapsed) {
        this.markAllAsRead();
      }
    }
  },

  mixins: [DataLayerMixin]
});
</script>
